import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ManufactureService {

 constructor(
             private http: HttpClient, 
             private global: GlobalDataService
            ) { } 

   getManufacture() {
        return this.http.get(this.global.httpUrl+"manufacturers");
   }

   getManufactureById(id: any) {
        return this.http.get(this.global.httpUrl+"manufacturers/"+id);
   } 

   createManufacture(data: any){
        return this.http.post(this.global.httpUrl+"manufacturers", data); 
   }

   updateManufacture(data: any,id: any){
        return this.http.put(this.global.httpUrl+"manufacturers/"+id, data); 
   } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/manufacturers/manufacture.service.ts